import Speed from "./SpeedCore.js";
import PlayerLocal from "./PlayerLocal.js";
import PlayerComputer from "./PlayerComputer.js";
import SocketIOClient from "./SocketIOClient.js";
import PlayerSocketIO_Simple from "./PlayerSocketIO_Simple.js";

export default class SpeedFactory {
    constructor() {
       
    }
    create(gameMode, level, server, userData, debug) {
        if (!userData) userData = {};

        //set up game core
        //setup core model, speed core
        let speed = new Speed();
        speed.gameMode = "2Player";

        var playerLocal = new PlayerLocal(speed,
            userData.name,
            userData.avatar,
            userData.id,
            userData.rank,
            userData.rating
        );


        var playerLocal1 = new PlayerLocal(speed, "Player 2");
        speed.PlayerTop = playerLocal1;

        speed.PlayerBottom = playerLocal;

        // //todo: save deck as full path or just name? full path will let it pull from internet
        // var deck = null;
        // if (userData.deck) {
        //     var item = Items.getItem(userData.deck);
        //     if (item) deck = item.url;
        // }
        // var background = null;
        // if (userData.background) {
        //     background = userData.background;
        // }
        // speed.deckUrl = deck;
        // speed.background = background;

        
    if (!gameMode) gameMode = "2Player";



    //set up game core
    //setup core model, speed core
    speed.gameMode = gameMode;
    speed.level = level;

    speed.showReplayButton = false;
    if (debug) speed.debug = debug;

    var playerLocal = new PlayerLocal(speed,
        userData.name,
        userData.avatar,
        userData.id,
        userData.rank,
        userData.rating
    );
    if (level === "Local" || level === "Easy" || level === "Medium" || level === "Hard" || level === "CrazyNinja" || level === "InsaneMonkey" || level === "UltraCheetah" || level === "Impossible") {
        var computerName = level;
        if (!computerName) computerName = "Hard";
        const PlayerTop = new PlayerComputer(speed, computerName, computerName);// player --> game com
        speed.PlayerTop = PlayerTop;
        speed.PlayerBottom = playerLocal;
        speed.gameMode = gameMode;
        return speed;
    }
    if (gameMode === "Online") {
        //todo: ready room page, show ad there too and online stats



        //var playerComputer = new PlayerComputer(speed, "CrazyNinja", "Comp" + Math.floor(Math.random() * 10000));// player --> game com
        //playerComputer.name = playerLocal.name + ".";
        //playerComputer.avatar = playerLocal.avatar;
        //playerComputer.id = playerLocal.id;
        //playerComputer.rank = playerLocal.rank;
        //playerComputer.rating = playerLocal.rating;
        //playerComputer.isLocal = true;



        //var playerSocketIO = new PlayerSocketIO(speed, "Searching...", playerComputer, room, !isPrivateGame);
        //speed.PlayerTop = playerSocketIO;
        //speed.PlayerBottom = playerComputer;

        speed.level = "Online";

        var isPrivateGame = false;
        var room = level;
        if (room) isPrivateGame = true;
        if (!room) room = 'lobby';

        var serverUrl = null;
        if (server) serverUrl = server;

        let socketIO = new SocketIOClient();
        socketIO.connect(serverUrl, userData);
        var playerSocketIO = new PlayerSocketIO_Simple(socketIO, speed, "Searching...", playerLocal, room, !isPrivateGame);

        speed.PlayerTop = playerSocketIO;
        speed.PlayerBottom = playerLocal;

        //var playerSocketIO = new PlayerSocketIO(speed, "Searching...", playerLocal, room,!isPrivateGame);
        //speed.PlayerTop = playerSocketIO;
        //speed.PlayerBottom = playerLocal;


        speed.isRanked = true;
        speed.showReplayButton = false;
        if (isPrivateGame) {
            speed.isRanked = false;
            speed.showReplayButton = true;
        }

    }

    if (gameMode === "OnlineTest") {


        //copy local play to computer for testing online
        var randomName = "PlayerC" + Math.floor(Math.random() * 10000);
        var playerComputer = new PlayerComputer(speed, "Hard", randomName);// player --> game com
        playerComputer.avatar = playerLocal.avatar;
        playerComputer.id = Math.floor(Math.random() * 10000);
        playerComputer.rank = playerLocal.rank;
        playerComputer.rating = playerLocal.rating;
        playerComputer.isLocal = true;


        var room = 'lobby';

        var serverUrl = null;
        if (server) serverUrl = server;

        // var fakeUserData = {
        //     id: Math.floor(Math.random() * 10000),
        //     name: "Player" + Math.floor(Math.random() * 10000),
        //     avatar: userData.avatar
        // };

        var socketIO = new SocketIOClient();
        if (!socketIO.isConnected()) socketIO.connect(serverUrl, playerComputer);
        var playerSocketIO = new PlayerSocketIO_Simple(socketIO, speed, "Searching...", playerComputer, room);

        speed.PlayerTop = playerSocketIO;
        speed.PlayerBottom = playerComputer;
        speed.isRanked = true;
        speed.gameMode = "Online";
        speed.level = "Online";

        var testGameOverTimer = null;
        var testTimeOutTimer = null;
        speed.onMessage4 = function (message, value) {
            //start over and play again
            if (message === "gameover") {
                var timeout = Math.floor(Math.random() * 10000) + 5000;
                testGameOverTimer = setTimeout(function () {
                    clearTimeout(testTimeOutTimer);
                    // location.reload();
                    window.location.href = "#/";
                    window.location.href = "#/Game/OnlineTest";
                }, timeout);
            }
            if (message === "start") {
                //incase game never ends, reset every 5 min
                testTimeOutTimer = setTimeout(function () {
                    // location.reload();
                    window.location.href = "#/";
                    window.location.href = "#/Game/OnlineTest";
                }, 1000 * 60 * 5);
            }
        }

    }


    if (gameMode === "Test") {
        var playerComputer = new PlayerComputer(speed, "Impossible", "Impossible");
        playerComputer.name = playerLocal.name + ".";
        playerComputer.avatar = playerLocal.avatar;
        playerComputer.id = playerLocal.id;
        playerComputer.rank = playerLocal.rank;
        playerComputer.rating = playerLocal.rating;
        playerComputer.isLocal = true;
        speed.PlayerTop = playerComputer;

        var levels = ["Easy", "Medium", "Hard", "CrazyNinja", "InsaneMonkey", "UltraCheetah", "Impossible"];
        var randLevel = levels[Math.floor(Math.random() * levels.length)];

        var playerComputer2 = new PlayerComputer(speed, randLevel, randLevel);
        speed.PlayerBottom = playerComputer2;


        speed.level = randLevel;
        speed.gameMode = "Classic";

        var testGameOverTimer = null;
        speed.onMessage4 = function (message, value) {
            //start over and play again
            if (message === "gameover") {
                var timeout = Math.floor(Math.random() * 10000) + 5000;
                //window.location.href = "#/";
                testGameOverTimer = setTimeout(function () {
                    //location.reload();
                    window.location.href = "#/";
                    window.location.href = "#/Game/Test";

                }, timeout);
            }
        }
    }



    return speed;
    }
}



